import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { history } from 'kts-platform-frame/routes';
import { Form, Modal, DatePicker, Button } from 'antd';
import moment from 'moment';

const css = require('./index.scss');
const FormItem = Form.Item;
const { MonthPicker } = DatePicker;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onCloseModal: ()=>void;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecordModal extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            this.modulesState.record.modal=false;
            ModulesAction.setModulesState();
            history.push({ pathname: `authRecord/detail`,search:`invoicePeriod=${values['invoicePeriod'].startOf('month').format('YYYY-MM')}`, state: { minQueryTime: values['invoicePeriod'].startOf('month').format('YYYY-MM-DD') } });
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { span: 6 }
        };
        return (
            <div>
                <Modal
                    visible={true}
                    onCancel={this.props.onCloseModal}
                    footer={null}
                    title="选择税期"
                >
                    <Form onSubmit={this.handleSubmit}>
                        <FormItem
                            {...formItemLayout}
                            label="税款所属期"
                        >
                            {getFieldDecorator('invoicePeriod', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择时间'
                                    }
                                ], initialValue: moment()
                            })(
                                <MonthPicker format={'YYYY-MM'} />
                            )}
                        </FormItem>
                        <div style={{ 'textAlign': 'center' }}>
                            <Button type="primary" htmlType="submit">查看明细</Button>
                        </div>
                    </Form>

                </Modal>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthRecord.Modal.tsx